<template>
  <a
    :class="{active}"
    :href="path"
    class="menu-item"
    @click.p.prevent="onClick">
    Athena
  </a>
</template>

<script>
export default {
  data() {
    return {
      path: '/athena'
    };
  },
  computed: {
    active() {
      return this.path === this.$store.path;
    }
  },
  methods: {
    onClick() {
      this.$store.navigate(this.path, {});
    }
  }
};
</script>
